import { render, staticRenderFns } from "./OfficePreviewBridge.vue?vue&type=template&id=0fc6718c&scoped=true"
import script from "./OfficePreviewBridge.vue?vue&type=script&lang=js"
export * from "./OfficePreviewBridge.vue?vue&type=script&lang=js"
import style0 from "./OfficePreviewBridge.vue?vue&type=style&index=0&id=0fc6718c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6718c",
  null
  
)

export default component.exports